// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"7f4326fc","61":"a6554671","259":"9c17aa70","269":"2f747dd5","444":"30c62e33","540":"5549487d","598":"8e284d86","647":"5c81616f","649":"995f4cd4","650":"40e85c9c","669":"b968305b","785":"132def45","929":"9be40fd3","936":"97d316ac","985":"ec855f23"}[chunkId] + ".chunk.js";
};